module.exports = __webpack_public_path__ + "static/media/icons8-medium-new.9817c7a1.svg";